import { render, staticRenderFns } from "./ActivitiesSelector.vue?vue&type=template&id=15bddb05&scoped=true"
import script from "./ActivitiesSelector.vue?vue&type=script&lang=js"
export * from "./ActivitiesSelector.vue?vue&type=script&lang=js"
import style0 from "./ActivitiesSelector.vue?vue&type=style&index=0&id=15bddb05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bddb05",
  null
  
)

export default component.exports